<template>
  <div class="cmp-settings-notices-notice_list dt-page">
    <v-layout row wrap>
      <v-flex md12 pa-1>
        <div>
          <NTable
            :id="'settings-notices-notice_list'"
            class="h1"
            :headers="noticeHeaders"
            :items="list"
          >
            <template v-slot:item="{ item, tdcon }">
              <tr
                @click="onNoticeClick(item)"
                :title="$t('click_to_see_notice_details')"
              >
                <td v-bind="tdcon('notices')" :title="getNoticeName(item)">
                  <div>{{ getNoticeHeader(getNoticeName(item)) }}</div>
                </td>
                <td v-bind="tdcon('created')">
                  <span>{{ item["created"].split(" ")[0] }}</span>
                </td>
              </tr>
            </template>
          </NTable>
        </div>
      </v-flex>
    </v-layout>

    <Sidewindow
      :navConfig="defaultConfig"
      :value="sidewindowFlag"
      @closed="onCloseNotice"
    >
      <div class="notice-details">
        <div class="notice-content" v-html="notice.notice"></div>
      </div>
    </Sidewindow>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { defaultConfig } from "@/dt-plugins/sidewindow/config.model";
import { createLDTHost } from "@/dt-plugins/sidewindow/LDTHost.mixin";
import { LDTHost } from "@/dt-plugins/sidewindow";
import NTable from "@/plugins/datatable/datatable";
import Sidewindow from "@dtplugins/sidewindow/sidewindow";

import {
  onDetailsRowClicked,
  childOfOrEqualDetails,
  handleFromRoute,
  getSelectableResult,
} from "../../../../utility/route";

import * as ActionTypes from "../../store/types";
import { SettingsStoreNamespace as storeNS } from "../../store";
import { createModalMixin } from "../../../../dt-plugins/modal/modal.mixin";
import { mapKeyToAction, mapActionObject } from "../../../../store/global";
import ModalContainer from "@dtplugins/modal/modal-container";
import { noticesSettingsActions } from "../../store/notices/actions";
import { noticesLDTRoutes } from "../../router/routes";
import { htmlToString } from "../../../../utility";
import { createTableHeader } from "../../../../plugins/datatable";

const listLength = 30;

export default {
  components: {
    ModalContainer,
    NTable,
    Sidewindow,
  },
  mounted: async function () {
    this.fetchList();
  },
  data: function () {
    return {
      defaultConfig: defaultConfig,
    };
  },
  mixins: [
    createLDTHost({
      entityName: "notice",
      ldtRoutes: noticesLDTRoutes,
      detailsSelectableFunction: getSelectableResult(noticesLDTRoutes),
      primaryKey: noticesLDTRoutes.primaryKey,
      storeNs: storeNS,
      SELECT_ACTION: ActionTypes.NoticesDetails.FETCH.SINGLE,
      SELECT_AUTO_ACTION: ActionTypes.NoticesDetails.FETCH.SINGLE,
    }),
  ],
  watch: {},
  computed: {
    ...mapGetters(storeNS, {
      noticesSettingsData: "noticesSettingsData",
      noticesDetails: "noticesDetails",
    }),
    list: function () {
      return this.noticesSettingsData?.notices || [];
    },
    noticeHeaders: function () {
      return [
        createTableHeader("notices", {
          text: this.$t("Notices"),
          fw: 500,
          f: 3,
        }),
        createTableHeader("created", { text: this.$t("Created") }),
      ];
    },
    client_notice_id: function () {
      return this.$route.params.client_notice_id;
    },
    notice: function () {
      return this.noticesDetails?.[this.client_notice_id] || {};
    },
  },
  methods: {
    ...mapActionObject(storeNS, noticesSettingsActions),

    fetchList: function () {
      this[ActionTypes.NoticesSettingsData.FETCH.ALL]();
    },
    getNoticeHeader: function (notice) {
      return notice.split("\n").filter((e) => /\w/.test(e))[0];
      // return notice?.notice.match(/<h2[.*>]+<h2>/)
    },
    getNoticeName: function (notice) {
      return htmlToString(notice?.notice) + "...";
    },
    onNoticeClick: function (notice) {
      this.$router.push({
        name: noticesLDTRoutes.names.details,
        params: {
          [noticesLDTRoutes.primaryKey]: notice[noticesLDTRoutes.primaryKey],
        },
      });
    },
    onCloseNotice: function () {
      this.$router.push({
        name: noticesLDTRoutes.names.list,
      });
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-settings-notices-notice_list {
  .dt-ntable {
    --ntable-height: calc(100vh -80px);
  }

  .notice-details {
    display: flex;
    justify-content: center;
    .notice-content {
      margin-top: 50px;
      height: calc(100vh - 50px);
      overflow: auto;
      div {
        display: flex;
        flex-direction: column;
        height: max-content;
      }
    }
  }
}
</style>
